import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function ControlLabel(theme: Theme, containerId: string) {
  return {
    MuiFormControlLabel: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        label: {
          ...theme.typography.body1,
        },
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        root: {
          marginTop: theme.spacing(1),
        },
      },
    },
    MuiFormLabel: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        root: {
          overflow: 'hidden',
          width: '89%',
          textOverflow: 'ellipsis',
          color: theme.palette.text.disabled,
        },
      },
    },
  };
}
